const messagesFR = {
    code: "fr",
    messages: {
        included: (field) => `"${field}" Entrez une valeur valide dans le champ`,
        url: (field) => `"${field}" le champ doit être une URL valide`,
        alpha: (field) => `"${field}" ne peut contenir que des lettres`,
        alpha_dash: (field) =>
            `"${field}" le champ peut contenir des lettres et des traits d'union (-) ou des traits de soulignement (_)`,
        alpha_num: (field) => `"${field}" ne peut contenir que des lettres ou des chiffres`,
        alpha_spaces: (field) => `"${field}" seules les lettres peuvent contenir des espaces`,
        between: (field, min, max) => `"${field}" ${min} avec ${max} devrait être dans la gamme`,
        confirmed: (field, field2) => `"${field}" la vérification est fausse ${field2} Et ${field} doit être le même`,
        digits: (field, length) => `"${field}" numérique et ${length} devrait être étagé`,
        dimensions: (field, width, height) =>
            `"${field}" zone ${width} avec pixels ${height} devrait être entre les pixels`,
        email: (field) => `"${field}" Le champ doit être un email valide`,
        excluded: (field) => `"${field}" n'est pas une valeur valide.`,
        ext: (field) => `"${field}" le champ doit être un fichier valide`,
        image: (field) => `"${field}" le champ doit être un fichier image`,
        oneOf: (field) => `"${field}" Entrez une valeur valide dans le champ`,
        max: (field, length) => `"${field}" zone ${length} pas plus d'un caractère`,
        max_value: (field, max) => `"${field}" zone ${max} devrait être une valeur de ou moins`,
        mimes: (field) => `"${field}" doit être un fichier valide`,
        min: (field, length) => `"${field}" zone au moins ${length} caractère doit être saisi`,
        min_value: (field, min) => `"${field}" zone ${min} doit être une valeur de ou plus`,
        numeric: (field) => `"${field}" Entrez une valeur numérique dans le champ`,
        regex: (field) => `"${field}" le format n'est pas valide`,
        required: (field) => `"${field}" l'espace est requis`,
        required_if: (field) => `"${field}" l'espace est requis`,
        size: (field, size) => `"${field}" zone ${size}Doit être inférieur à Ko`,
        length: (field, len) => `"${field}" zone ${len} le personnage doit être`,
    },
};

export default messagesFR;
